import { MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import styles from "./FilterView.module.scss";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";

import utc from "dayjs/plugin/utc"; 
import { AggregateWindow } from "../../../types/types";


import Button from "../../../../../components/atom/Button/Button";

dayjs.extend(utc);

export type Preset = "today" | "this-month" | "this-year";

export interface FilterViewProps {
  aggregateWindow?: AggregateWindow | null;
  setAggregateWindow: (aggregateWindow: AggregateWindow) => void;
  devEuiValue?: string;
  setDevEuiValue?: (devEuiValue: string) => void;
  onSubmit?: () => void;
  isLoading?: boolean;
  handleNextWindow?: () => void;
  handlePreviousWindow?: () => void;
  setDateStart?: (date: Date | null) => void;
  setDateStop?: (date: Date | null) => void;
  dateStart?: Date;
  dateStop?: Date;
  onClickPreset?: (Presets: Preset) => void;
  disabledSubmit?: boolean;
  disabledAggregation?: AggregateWindow[];
  presetWindowActive?: Preset;
  onApply?: () => void;
  handleClose?: () => void;
}
export default function FilterView({
  aggregateWindow,
  setAggregateWindow,
  setDevEuiValue,
  devEuiValue,
  onSubmit,
  isLoading,
  handleNextWindow,
  handlePreviousWindow,
  setDateStart,
  setDateStop,
  dateStart,
  dateStop,
  onClickPreset,
  disabledSubmit,
  disabledAggregation,
  presetWindowActive,
  onApply, 
  handleClose
  

}: FilterViewProps) {
  const handleChange = (event: SelectChangeEvent) => {
    setAggregateWindow(event.target.value as AggregateWindow);
  };



  const handleDateStartChange = (date: Dayjs | null) => {
    const dateValue = date?.utc().toDate() || null;

    setDateStart && setDateStart(dateValue);
  
  };

  const handleDateStopChange = (date: Dayjs | null) => {
    const dateValue = date?.utc().toDate() || null;

    setDateStop && setDateStop(dateValue);
   
  };

  const handleOnClickPreset = (preset: Preset) => {
      onClickPreset && onClickPreset(preset);
      if (handleClose) {
        handleClose();
      }
  }



  const checkDisabledAggregation = (value: AggregateWindow) => {
    return disabledAggregation?.includes(value);
  }


  return (
    <>


    
          <div className={styles["modal-content"]}>
            <div
              className={[styles["container"], styles["container--left"]].join(
                " "
              )}
            >
              <h2 className={styles["container__title"]}>Aggrégation</h2>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={aggregateWindow || ""}
                onChange={handleChange}
              >
                <MenuItem value={"1h"} disabled={checkDisabledAggregation('1h')}>Par heure</MenuItem>
                <MenuItem value={"1d"}  disabled={checkDisabledAggregation('1d')}>Par jour</MenuItem>
                <MenuItem value={"1mo"}  disabled={checkDisabledAggregation('1mo')}>Par mois</MenuItem>
              </Select>
            </div>
            <div className={styles["separator"]} />
            <div
              className={[styles["container"], styles["container--right"]].join(
                " "
              )}
            >
              <h2 className={styles["container__title"]}>Intervalle</h2>

              {onClickPreset && (
                <div className={styles["preset_container"]}>
                  <h3 className={styles["container__sub-title"]}>
                    Invervalles prédéfinis
                  </h3>
                  <div className={[styles["preset_container__btn"]].join(" ")}>
                    <Button
                      onClick={() => { handleOnClickPreset("today"); }}
                      variant={ presetWindowActive === "today" ? "primary" : "outlined"}
          
                    >
                      Aujourd'hui
                    </Button>
                  </div>
                  <div className={[styles["preset_container__btn"]].join(" ")}>
                    <Button
                      onClick={() => { handleOnClickPreset("this-month")}}
                      variant={ presetWindowActive === "this-month" ? "primary" : "outlined"}
              
                 
                    >
                      Ce mois-ci
                    </Button>
                  </div>
                  <div className={[styles["preset_container__btn"]].join(" ")}>
                    <Button
                      onClick={() => { handleOnClickPreset("this-year")}}
                      variant={ presetWindowActive === "this-year" ? "primary" : "outlined"}
                
            
                    >
                      Cette année
                    </Button>
                  </div>
                </div>
              )}
              <div className={styles["custom-interval-container"]}>
                <h3 className={styles["container__sub-title"]}>
                  Invervalle personalisé
                </h3>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div
                    className={[
                      styles["custom-interval-container__input"],
                      styles["custom-interval-container__input--date-start"],
                    ].join(" ")}
                  >
                    <DatePicker
                      label="Date de début"
                      onChange={handleDateStartChange}
                      value={dateStart && dayjs(dateStart)}
                      format="DD/MM/YYYY"
                      timezone="UTC"
                    />
                  </div>
                  <div
                    className={[
                      styles["custom-interval-container__input"],
                      styles["custom-interval-container__input--date-end"],
                    ].join(" ")}
                  >
                    <DatePicker
                      label="Date de fin"
                      onChange={handleDateStopChange}
                      value={dateStop && dayjs(dateStop)}
                      minDate={dateStart && dayjs(dateStart)}
                      format="DD/MM/YYYY"
                      timezone="UTC"
                    />
                  </div>
                </LocalizationProvider>
              </div>
            </div>
          </div>
          <div className={styles["btn-container"]}>
            <Button
              onClick={() => {
                onSubmit && onSubmit();
                if (handleClose){
                  handleClose();
                }
              }}
        
              variant="tertiary"
        
        
            >
              Annuler
            </Button>
                        <Button
              onClick={() => {
                onSubmit && onSubmit();
                if (handleClose){
                  handleClose();
                }
       
                onApply && onApply();
              }}
        
              variant="primary"
        
              disabled={disabledSubmit}
            >
              Appliquer
            </Button>
          </div>

    </>
  );
}
